import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-footer-totals-block',
  templateUrl: './footer-totals-block.component.html',
  styleUrls: ['./footer-totals-block.component.scss'],
  standalone: false
})
export class FooterTotalsBlockComponent {
  @Input() visible: boolean = false;

  @Input() subtotal: number = 0;
  @Input() total: number = 0;
}
